import React, { useId } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export interface AlertDialogProps {
  open: boolean;
  message: string;
  onClose: () => void;
  title?: string;
  closeText?: string;
}

/** ブラウザ標準の alert() の代わりに使う、OKボタンのみのダイアログ。 */
const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  message,
  onClose,
  title = 'エラー',
  closeText = 'OK',
}) => {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent id={descriptionId}>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" autoFocus>
          {closeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
